import { client, getUrl } from "utils";

export const getTestCaseRequest = (id) =>
    client.get(`config-ci-test-task/${id}/test-case-tasks`)
        .then(({ config_ci_test_case_tasks }) => (config_ci_test_case_tasks));

export const getPublishRequestsRequest = (filterParams) => client.get(getUrl("publish-requests", filterParams));

export const getConfigCiTestTasksRequest = (filterParams) => (
    client.get(getUrl("config-ci-test-tasks", filterParams))
        .then(({ config_ci_test_tasks }) => ({ [filterParams.publish_request_id]: config_ci_test_tasks }))
);

export const acceptPublishRequestRequest = ({ id, ...data }) => client.patch(`publish-request/${id}/accept`, data);

export const configCiTestCaseTaskCancelRequest = ({ id, ...data }) => client.patch(`config-ci-test-case-task/${id}/cancel`, data);

export const publishRequestRejectRequest = ({ id, ...data }) => client.patch(`publish-request/${id}/reject`, data);
